"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginateListAssignmentAssistants = void 0;
const Apiv2Client_1 = require("../Apiv2Client");
const ListAssignmentAssistantsCommand_1 = require("../commands/ListAssignmentAssistantsCommand");
const core_1 = require("@smithy/core");
exports.paginateListAssignmentAssistants = (0, core_1.createPaginator)(Apiv2Client_1.Apiv2Client, ListAssignmentAssistantsCommand_1.ListAssignmentAssistantsCommand, "nextToken", "nextToken", "pageSize");
